import { FormEventHandler, useEffect, useRef } from "react"

import { FormField } from "../../common/interfaces"

import styles from "./style.module.scss"

import { Input } from "ui-kit/components-branded/FormControls/Input/Input"
import { ActionButtons } from "modules/ClientAuthorization/components/ActionButtons"
import { focusInput } from "utils/helpers/focusInput"

interface Props {
    handleSubmit: FormEventHandler<HTMLFormElement>
    showErrors: boolean
    buttonDisabled: boolean
    nameField: FormField
    emailField: FormField
    promocodeField?: FormField
}

export const RegistrationCard = ({
    handleSubmit,
    showErrors,
    buttonDisabled,
    emailField,
    nameField,
    promocodeField,
}: Props) => {
    const emailInputRef = useRef<HTMLInputElement | null>(null)
    const nameInputRef = useRef<HTMLInputElement | null>(null)
    const promocodeInputRef = useRef<HTMLInputElement | null>(null)

    useEffect(() => {
        if (!showErrors) return

        if (emailField.error) {
            focusInput(emailInputRef)
        } else if (nameField.error) {
            focusInput(nameInputRef)
        } else if (promocodeField?.error) {
            focusInput(promocodeInputRef)
        }
    }, [showErrors, emailField.error, nameField.error, promocodeField?.error])

    return (
        <form onSubmit={handleSubmit} className={styles.container}>
            <div>
                <div className={styles.headline}>Создайте личный кабинет</div>
                <div className={styles.text}>
                    В&nbsp;нем будут все ваши сессии, контакты психолога и&nbsp;полезные материалы.
                </div>
            </div>
            <div>
                <Input
                    ref={emailInputRef}
                    error={emailField.error}
                    label="Ваша почта"
                    name="email"
                    value={emailField.value}
                    onChange={emailField.setValue}
                    autoFocus
                />
                <Input
                    ref={nameInputRef}
                    error={nameField.error}
                    isMiddleSpacesAllowed
                    label="Имя"
                    name="name"
                    value={nameField.value}
                    onChange={nameField.setValue}
                />
                {promocodeField && (
                    <Input
                        ref={promocodeInputRef}
                        error={promocodeField.error}
                        isMiddleSpacesAllowed
                        label="Промокод"
                        name="promocode"
                        value={promocodeField.value}
                        onChange={promocodeField.setValue}
                    />
                )}
                <ActionButtons
                    showPersonalInfo
                    disabled={buttonDisabled}
                    actionButtonLabel="Зарегистрироваться"
                />
            </div>
        </form>
    )
}
